import React, { useEffect } from "react";
import { IC } from "../../../../resources/Assets";
import styled from "styled-components";

const ToastMsg = props => {
  const { option } = props;
  return (
    <Background bottom={option.bottom}>
      <StatusImg src={IC.check.ICON_GREEN_CHECK} />
      <Message>{option.text}</Message>
    </Background>
  );
};

export const toastMsgObj = {
  famzAdd: {
    img: IC.check.ICON_GREEN_CHECK,
    text: "가족정보가 추가되었습니다",
  },

  famzDelete: {
    img: IC.check.ICON_GREEN_CHECK,
    text: "가족정보가 삭제되었습니다",
  },

  cardAdd: {
    img: IC.check.ICON_GREEN_CHECK,
    text: "결제카드가 추가되었습니다.",
  },
};

const Background = styled.div`
  /* z-index: 100; */
  position: absolute;
  bottom: ${props => (props.bottom ? props.bottom : "102px")};
  box-sizing: border-box;
  width: calc(100% - 40px);
  height: 56px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 16px 20px 16px 16px;
  border-radius: 12px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.15), 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  background-color: rgba(0, 0, 0, 0.85);
  will-change: transform;
`;

const StatusImg = styled.img`
  width: 24px;
  height: 24px;
  flex-grow: 0;
  padding: 8px 6.7px 8px 6px;
  border-radius: 12px;
  /* background-color: #22c55e; */
`;

const Message = styled.span`
  height: 22px;
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #fff;
`;
export default ToastMsg;
